import React from 'react';
import './Evaluaciones.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import EvaluacionesData from '../../Components/Admin/EvaluacionesData/EvaluacionesData';

export default function Evaluaciones() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection evaluacionesContainer'>
                <HeaderDash />
                <div className='evaluaciones-container-wrapper'>
                    <EvaluacionesData />
                </div>
            </section>
        </div>
    );
}







